import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Media } from '../../entity/api/media';
import { createBasicStoreState } from './basic-store';

type TModel = Media;

/**
 * Media Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, updateMultipleToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from media-queries.ts:
 * - useMediaList()
 * - useMediaByRefDocId(refDocId)
 * - useCreateMedia()
 *
 * For cache access, use helpers from media-queries.ts:
 * - getMediaFromCache(queryClient, id)
 * - getMediaListFromCache(queryClient)
 * - getMediaByRefDocIdFromCache(queryClient, refDocId)
 * - getMediaByRefDocIdAndKindFromCache(queryClient, refDocId, kind)
 * - setMediasInCache(queryClient, medias)
 * - setMediaInCache(queryClient, media)
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'media' }
  )
);
